
import React, { createElement } from "react"
import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import { setErrorMessage, setMessage, clearMessage, settopMessage } from "../tools/errorhandling";
import { BiSolidPlaneLand } from "react-icons/bi";
import { FaBellConcierge } from "react-icons/fa6";

import {
    getMyLinkedhotels, getAllhotelsForAdministrator, getsupervisorcleaningassignments, getsupervisorcleaningassignmentsfordate, getAllHotelData, assigmentQualityControled, updateCleaningassignment, getView
} from "../dbconnector/connector";

import './css/tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';
import { FiAlertTriangle } from "react-icons/fi";
import { ImExit } from "react-icons/im";
import { FaBed } from "react-icons/fa";
import { IoIosFlash } from "react-icons/io";
import { FaRegStar } from "react-icons/fa";
import { BsCalendar2DayFill } from "react-icons/bs";
import { FaCalendarWeek } from "react-icons/fa6";
import { FaCalendarXmark } from "react-icons/fa6";
import { FaServicestack } from "react-icons/fa";
import QualityControlNode from '../customNodes/QualityControlNode';
import IssueReportNode from '../customNodes/IssueReportNode';
import AssignmentDetailNode from '../customNodes/AssignmentDetailNode';
import Dagstaat_per_medewerker from '../customNodes/Dagstaat_per_medewerker';
//dagstaat_per_medewerker
import { FaRegEye } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import { RotatingLines } from "react-loader-spinner";
import { GoTasklist } from 'react-icons/go';
import { MdOutlineSummarize } from 'react-icons/md';
import Moment, { now } from 'moment';
import { GoDotFill } from "react-icons/go";
import { GoDot } from "react-icons/go";
import { MdCleaningServices } from "react-icons/md";



const ViewCleaningAssignments = (props) => {
    const t = props.translation
    const [linkedhotels, setLinkedHotels] = useState({});
    const [roostersapproved, setRoosterapproved] = useState({});
    const [planned, setPlanned] = useState({});
        const [defaultplanned, setDefaultPlanned] = useState({});
    const [tabs, setTabs] = useState([]);
    const [tabpanels, setTabPanels] = useState([]);
    const [tabpanelscontent, setTabPanelscontent] = useState([]);
    const [selectedtab, setSelectedtab] = useState(0);
    const [SelectedhotelObject, setSelectedhotelObject] = useState([]);
    const [cleaningassignment, setCleaningassignment] = useState({});
    const [assignmentDisabled, setassignmentDisabled] = useState(false);
    const [showQAcontroller, setshowQAcontroller] = useState(false);
    const [assignments, setassignments] = useState({});
    const [selectedhotel, setSelectedHotel] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date().toLocaleDateString('en-CA'))
    const [reportdisplayed, setReportdisplayed] = useState(false);
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);
    let { id } = useParams();



    const statusmatrix = {
        0: "assigned",
        6: "DND",
        1: "started",
        2: "QAcontroled",
        3: "readyforQA",
        4: "Issuereported",
        5: "Rework"
    }

    useEffect(() => {
        document.getElementById("FullscreenBlocker").style.display = "none";
        document.getElementById("RotatinglinesText").innerText = "data wordt opgehaald, even geduld"
        document.getElementById("selectedRoosterDate").value = new Date().toLocaleDateString('en-CA')
        const interval = setInterval(() => {
            Refreshsupervisorcleaningassignmentsfordate();
        }, 60000); // Refresh every 30 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
    ////console.log("vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv")
getActiveHotels();
 //buildtabs();
    }, [selectedDate]);

    useEffect(() => {
        try {
            if (sessionStorage.getItem('selectedDateOverview') !== null && sessionStorage.getItem('selectedDateOverview').length > 0) {

                let DateSession = Moment(new Date(sessionStorage.getItem('selectedDateOverview')))
                    .utc()
                    .format('yyyy-MM-DD');
                document.getElementById("selectedRoosterDate").value = DateSession
                setSelectedDate(DateSession)
            }
            if (sessionStorage.getItem('viewQAcontroled') !== null && sessionStorage.getItem('viewQAcontroled').length > 0) {
                let QAchecked = sessionStorage.getItem('viewQAcontroled')
                document.getElementById("checkboxQAcontrolled").checked = QAchecked
            }
            if (sessionStorage.getItem('selectedoverviewtabid') !== null && sessionStorage.getItem('selectedoverviewtabid').length > 0) {
                let tabid = Number(sessionStorage.getItem('selectedoverviewtabid'))
                setSelectedtab(tabid)
            }
            getActiveHotels()
        } catch (e) {
            setErrorMessage(t("error_retreivingData"))
        }
    }, []);

    useEffect(() => {
        if (linkedhotels.length > 0) {
            buildtabs()

            if (sessionStorage.getItem('selectedoverviewtabid') !== null) {
                setSelectedhotelObject(linkedhotels[Number(sessionStorage.getItem('selectedoverviewtabid'))])
                getassigmentsforhotel(linkedhotels[Number(sessionStorage.getItem('selectedoverviewtabid'))])
            } else {
                setSelectedhotelObject(linkedhotels[0])
                getassigmentsforhotel(linkedhotels[0])
            }
        }
    }, [linkedhotels]);

    const getActiveHotels = () => {
        setLinkedHotels({})
        setTabPanelscontent([])
        if (props.rights === 2) {
            const response = getAllhotelsForAdministrator(selectedDate)
            response.then(res => {
                if (res.status === 200) {

                    res.json().then(linkedhotels => {
                        console.log("linkedhotels ", linkedhotels)
                        setRoosterapproved(linkedhotels.roosterapproved)
                        setPlanned(linkedhotels.planned)
                        setDefaultPlanned(linkedhotels.defaultplanned)
                        setLinkedHotels(linkedhotels.hotels)
                        linkedhotels.hotels.forEach((hotel, index) => {
                            if ((linkedhotels.planned[hotel.hotel_Id].length > 0 && linkedhotels.planned[hotel.hotel_Id][0].total > 0) || (linkedhotels.defaultplanned[hotel.hotel_Id].length > 0 && linkedhotels.defaultplanned[hotel.hotel_Id][0].total > 0)) {
                                document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'visible'
                            } else {
                                document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'hidden'
                            }

                        })

                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        } else {
            const response = getMyLinkedhotels()
            response.then(res => {

                if (res.status === 200) {
                    res.json().then(linkedhotels => {
                        ////console.log("linkedhotels ", linkedhotels)
                        setRoosterapproved(linkedhotels.roosterapproved)
                        setPlanned(linkedhotels.planned)
                         setDefaultPlanned(linkedhotels.defaultplanned)
                        setLinkedHotels(linkedhotels.hotels)
                          linkedhotels.hotels.forEach((hotel, index) => {
                            if ((linkedhotels.planned[hotel.hotel_Id].length > 0 && linkedhotels.planned[hotel.hotel_Id][0].total > 0) || (linkedhotels.defaultplanned[hotel.hotel_Id].length > 0 && linkedhotels.defaultplanned[hotel.hotel_Id][0].total > 0)) {
                                document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'visible'
                            } else {
                                document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'hidden'
                            }

                        })
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }
    const setselectedtab = (tabid, hotel) => {
        setSelectedtab(tabid)
        setSelectedhotelObject(hotel)
        sessionStorage.setItem('selectedoverviewtabid', tabid)
        sessionStorage.setItem('selectedhotelId_overview', hotel.hotel_Id)
        getassigmentsforhotel(hotel)
    }



    function getassigmentsforhotel(hotel) {

        if (document.getElementById("selectedRoosterDate") !== null && document.getElementById("selectedRoosterDate") !== undefined && document.getElementById("selectedRoosterDate").value !== undefined) {
            sessionStorage.setItem('selectedDateOverview', document.getElementById("selectedRoosterDate").value)
            setSelectedDate(document.getElementById("selectedRoosterDate").value);
            getAllHotelData(document.getElementById("selectedRoosterDate").value, hotel.hotel_Id).then(res => {
                if (res.status === 200) {
                    res.json().then(data => {

                        if (data.hotels.length > 0 && data.hotels[0].nr_afd !== undefined) {
                            setassignments({})
                            setassignments(data)
                            buildtabcontent(hotel, data)
                        }
                        else {
                            //////console.log("WRONG return from getsupervisorcleaningassignmentsfordate =", data)
                        }
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            });
        }

    }


    const buildtabcontent = (hotel, data) => {
        //////console.log("selectedDate", document.getElementById("selectedRoosterDate").value)
        setTabPanelscontent([])
        const assignments = buildassignmentpanels(data.assignments[hotel.hotel_Id], "normal")
        // const specialassignments = buildspecialassignmentpanels(data.specialAssignments[hotel.hotel_Id], "special")
        const defaultassignments = builddefaultassignmentpanels(data.defaults[hotel.hotel_Id])
        const message = checkassignmentspressence(data.assignments[hotel.hotel_Id], data.specialAssignments[hotel.hotel_Id])

        setTabPanelscontent(pre => [...pre,
        <div className="tabpanel">
            <p className="historynotavailable" style={document.getElementById("selectedRoosterDate").value >= Moment().add(-1, 'months').format("YYYY-MM-DD") ? { display: "none" } : { display: "block" }}>
                Historische gegevens zijn maar gedurende 1 maand beschikbaar. Oudere gegevens zijn beschikbaar op aanvraag.
            </p>
            <Button onClick={() => showpayedtasks(hotel.hotel_Id)} style={document.getElementById("selectedRoosterDate").value >= Moment().add(-1, 'months').format("YYYY-MM-DD") ? { display: "block" } : { display: "none" }}><MdOutlineSummarize /></Button>
            <br></br>
            <div id={'hotel_div' & hotel.hotel_Id} className="AssignmentTabs">

                {assignments}
                {message}
            </div>
            <label className='DefaultAssignmentsTitle'>{t('Specifieketaken')}</label>
            <div className="DefaultAssignmentTabsOverview">
                {defaultassignments}
            </div>
        </div>
        ])
    }

    function Refreshsupervisorcleaningassignmentsfordate() {
        ////console.log("refreshing")
        if (document.getElementById("selectedRoosterDate") !== null && document.getElementById("selectedRoosterDate") !== undefined && document.getElementById("selectedRoosterDate").value !== undefined) {
            sessionStorage.setItem('selectedDateOverview', document.getElementById("selectedRoosterDate").value)
            setSelectedDate(document.getElementById("selectedRoosterDate").value);
        }
        getassigmentsforhotel(SelectedhotelObject)
    }

    const showpayedtasks = (hotelid) => {
        setSelectedDate(undefined)
        setSelectedHotel(null)
        document.getElementById("QualityControlNode").style.display = "none"
        document.getElementById("dagstaatpermedewerker").style.display = "none"
        document.getElementById("assignmentIssuedetails").style.display = "none"
        document.getElementById("assignmentDetailsNode").style.display = "none"
        setSelectedDate(document.getElementById("selectedRoosterDate").value);
        setSelectedHotel(hotelid)
        document.getElementById("coverAll").style.display = "block"
        document.getElementById("dagstaatpermedewerker").style.display = "block"


    }

    const onchangeQAcontrolled = (e) => {
        setshowQAcontroller(e.target.checked)
        sessionStorage.setItem('viewQAcontroled', e.target.checked)
        ////console.log("SelectedhotelObject :", SelectedhotelObject)
        Refreshsupervisorcleaningassignmentsfordate()
    }

    const buildtabs = () => {
        setTabs([])
       //console.log("roostersapproved = ", roostersapproved)
        if (linkedhotels.length > 0) {

            linkedhotels.forEach((hotel, index) => {
                let hasAssignments = false
                
                if (planned[hotel.hotel_Id].length > 0) {
                    hasAssignments = true
                }
                setTabs(pre => [...pre,
                <Tab id={String(hotel.hotel_Id)} key={index} onClick={() => setselectedtab(index, hotel)}> {hotel.nr_afd !== undefined ? hotel.nr_afd : index} - {hotel.Name} <GoDot id={'GoDot_' + hotel.hotel_Id} style={hasAssignments === true ? { visibility: "visible" } : { visibility: 'hidden' }} /></Tab>
                ])
            })
        }

    }

    const builddefaultassignmentpanels = (defaults) => {
        let kamerpanels = [];
        const t = props.translation


        if (defaults.length > 0) {
            defaults.forEach(defaultsassignment => {
                if (defaultsassignment.status !== 2 || document.getElementById("checkboxQAcontrolled").checked) {
                    if (defaultsassignment.status === 2 || !document.getElementById("checkboxQAcontrolled").checked) {
                        kamerpanels.push(
                            <div>
                                <Button className={"DefaultOverviewAssignmentButton CleaningTypeButton_status" + defaultsassignment.status} onClick={() => Createcleaningassignment(defaultsassignment)}  >
                                    <center>
                                        <div className='assignmenttitle'>{defaultsassignment.title}</div>
                                        <div className='defaultkamertypenaam'>{defaultsassignment.voornaam} {defaultsassignment.achternaam}</div>
                                        <div className={"DT_somethingsWrong_status" + defaultsassignment.status} style={defaultsassignment.HasIssues === 1 ? { display: 'block' } : { display: 'none' }}><FiAlertTriangle /></div>
                                    </center>
                                </Button>
                                <Button className="detailsbuttonassignment" onClick={() => showdetails(defaultsassignment, false)} style={selectedDate >= Moment().add(-1, 'months').format("YYYY-MM-DD") ? { visibility: 'visible' } : { visibility: 'hidden' }}>
                                    <FaRegEye className='detailsicon' />
                                </Button>
                            </div>
                        )
                    }
                }
            })
        } else {
            kamerpanels.push(
                <div className="NoRoomsLinked doublegrid"><center>
                    {t('geenspecifiekeopdrachtenlopende')}
                </center>
                </div>)
        }
        return kamerpanels
    }

    const buildassignmentpanels = (assignments, type) => {
        let kamerpanels = [];
        if (assignments.length > 0) {
            assignments.forEach(assignment => {
                // ////console.log("selectedDate ", selectedDate)
                if (assignment.status !== 8) {
                    let payedtasks = false
                    //var test = JSON.parse(assignment.multiple)
                    if (assignment.multiple.length > 2) {
                        payedtasks = true;
                    }
                    if (assignment.status !== 2 || document.getElementById("checkboxQAcontrolled").checked) {

                        if (assignment.status === 2 || !document.getElementById("checkboxQAcontrolled").checked) {
                            kamerpanels.push(
                                <div>
                                    <Button className={"assignmentButton CleaningTypeButton_status" + assignment.status} onClick={() => Createcleaningassignment(assignment)}  >

                                        <div style={assignment.cleaningtype_type === 1 ? { display: 'grid' } : { display: "none" }} className="Icongrid"><ImExit /><GoTasklist style={payedtasks === true ? { display: 'block' } : { display: "none" }} /></div>
                                        <div style={assignment.cleaningtype_type === 0 ? { display: 'grid' } : { display: "none" }} className="Icongrid"><FaBed /> <GoTasklist style={payedtasks === true ? { display: 'block' } : { display: "none" }} /></div>
                                        <div style={assignment.cleaningtype_type === 2 ? { display: 'grid' } : { display: "none" }} className="Icongrid"><IoIosFlash /><GoTasklist style={payedtasks === true ? { display: 'block' } : { display: "none" }} /></div>
                                        <div style={assignment.cleaningtype_type === -2 ? { display: 'block' } : { display: "none" }}><FaRegStar /></div>
                                        <div style={assignment.cleaningtype_type === 3 ? { display: 'block' } : { display: "none" }}><BsCalendar2DayFill /></div>
                                        <div style={assignment.cleaningtype_type === 4 ? { display: 'block' } : { display: "none" }}><FaCalendarWeek /></div>
                                        <div style={assignment.cleaningtype_type === 5 ? { display: 'block' } : { display: "none" }}><FaCalendarXmark /></div>
                                        <div style={assignment.cleaningtype_type === -1 ? { display: 'block' } : { display: "none" }}><FaServicestack /></div>

                                        <center>
                                            <div className='assignmenttitle'>{assignment.title}</div>
                                            <div className='kamertypenaam'>{assignment.kamerType}</div>
                                            <div className='assigneenaam'>{assignment.voornaam} {assignment.achternaam}</div>
                                            <div className="checkin_checkout">

                                                <div className={"somethingsWrong_status" + assignment.status} style={assignment.HasIssues === 1 ? { display: 'block' } : { display: 'none' }}><FiAlertTriangle /></div>

                                                <FaBellConcierge style={{ display: assignment.checkedout === 1 ? "flex" : "none", fontSize: '12pt' }}></FaBellConcierge>
                                                <BiSolidPlaneLand style={{ display: assignment.arrival === 1 ? "flex" : "none", fontSize: '12pt' }}></BiSolidPlaneLand>

                                            </div>
                                        </center>
                                    </Button>
                                    <Button className="detailsbuttonassignment" onClick={() => showdetails(assignment, false)} style={document.getElementById("selectedRoosterDate").value >= Moment().add(-1, 'months').format("YYYY-MM-DD") ? { visibility: 'visible' } : { visibility: 'hidden' }}>
                                        <FaRegEye className='detailsicon' />
                                    </Button>
                                </div>
                            )
                        }
                    }

                }
            })
        }
        return kamerpanels
    }
    const checkassignmentspressence = (assignments, specialassignments) => {
        let kamerpanels = [];
        if (assignments.length === 0 && specialassignments.length === 0) {
            kamerpanels.push(
                <div className="NoRoomsLinked"><center>
                    {t('geenspecifiekeopdrachtenlopende')}
                </center>
                </div>)
        }
        return kamerpanels
    }

    const showdetails = (assignment, showreport, e) => {

        setReportdisplayed(showreport)
        if (assignment !== null) {
            resetform(showreport);
            setCleaningassignment(assignment);
            setassignmentDisabled(false);
            document.getElementById("assignmentDetailsNode").style.display = "block"
            resetzindexes("assignmentDetailsNode")

            document.getElementById("coverAll").style.display = "block"
        }
    }

    const closereport = () => {
        setReportdisplayed(false)
        document.getElementById("dagstaatpermedewerker").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }

    const handleCancel = () => {
        setCleaningassignment([]);
        document.getElementById("QualityControlNode").style.display = "none"
        document.getElementById("assignmentIssuedetails").style.display = "none"
        if (!reportdisplayed)
            document.getElementById("coverAll").style.display = "none"
        document.getElementById("assignmentDetailsNode").style.display = "none"
    }


    const handleQACheck = () => {
        if (document.getElementById("QAOk").checked === true) {
            cleaningassignment.status = 2
        }
        if (document.getElementById("QARECLEAN").checked === true) {
            cleaningassignment.status = 5
        }
        updateCleaningassignment(cleaningassignment, cleaningassignment.id).then(res => {
            if (res.status === 200) {
                Refreshsupervisorcleaningassignmentsfordate();
            } else {
                setErrorMessage(res.statusText)
            }
        })
        document.getElementById("QualityControlNode").style.display = "none"
        document.getElementById("assignmentIssuedetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }

    const handleIssue = () => {
        const response = assigmentQualityControled(cleaningassignment.id, 1)
        response.then(res => {
            if (res.status === 200) {
                Refreshsupervisorcleaningassignmentsfordate();
            } else {
                setErrorMessage(res.statusText)
            }
        }
        )
        document.getElementById("QualityControlNode").style.display = "none"
        document.getElementById("assignmentIssuedetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }

    const Createcleaningassignment = async (assignment) => {
        ////console.log("assignment ", assignment)
        if (assignment.status > 2) {
            resetform(false);
            setCleaningassignment(assignment);
            setassignmentDisabled(false);

            if (assignment.status === 3) {
                document.getElementById("QualityControlNode").style.display = "block"
                document.getElementById("assignmentDetailsNode").style.display = "none"
                document.getElementById("coverAll").style.display = "block"

            }
            if (assignment.status === 4) {
                document.getElementById("assignmentIssuedetails").style.display = "block"
                document.getElementById("coverAll").style.display = "block"
            }
        }
    }

    function resetform(showreport) {
        document.getElementById("QAOk").checked = false
        document.getElementById("QAOk").disabled = false;
        document.getElementById("QARECLEAN").checked = false
        document.getElementById("QAopmerkingen").value = ""
        //clear issue report form
        document.getElementById("issueresolution").value = ""
        document.getElementById("extratime").value = ""
        // set all forms to invisible
        document.getElementById("QualityControlNode").style.display = "none"
        document.getElementById("assignmentIssuedetails").style.display = "none"

        if (!showreport) {
            document.getElementById("employeedetails").style.display = "none";
            document.getElementById("dagstaatpermedewerker").style.display = "none"
        }
        else {
            document.getElementById("dagstaatpermedewerker").style.display = "block"
            document.getElementById("employeedetails").style.display = "block";
        }
    }

    const handleOnchange = (e) => {
        setCleaningassignment(pre => ({ ...pre, [e.target.name]: e.target.value }))
    }

    const handleOnchangeCheck = (e) => {
        setCleaningassignment(pre => ({ ...pre, [e.target.name]: e.target.checked }))
    }

    const handleCheck = (e) => {
        handleOnchange(e)
        setassignmentDisabled(e.target.checked)
    }

    const handleCheckissue = (e) => {

        setCleaningassignment(pre => ({ ...pre, "IssueResolved": true }))
        setassignmentDisabled(true)
        handleIssue()
    }

    const handleQAOnchange = (e) => {
        setCleaningassignment(pre => ({ ...pre, [e.target.name]: e.target.value }))
    }

    const QAChecked = (e) => {
        setassignmentDisabled(e.target.checked)
    }

    const RECLEANChecked = (e) => {
        document.getElementById("QAOk").disabled = document.getElementById("QARECLEAN").checked
        //setassignmentDisabled(e.target.checked)
    }

    const resetzindexes = (windowname) => {

        document.getElementById("assignmentDetailsNode").style.zIndex = 1
        document.getElementById("QualityControlNode").style.zIndex = 1
        document.getElementById("assignmentIssuedetails").style.zIndex = 1
        document.getElementById("dagstaatpermedewerker").style.zIndex = 1
        document.getElementById(windowname).style.zIndex = 2
    }
    const startdrag = (windowname, drag, e) => {
        //"assignmentDetailsNode"
        //assignmentdetails
        //assignmentIssuedetails
        //dagstaatpermedewerker
        setWindowtodrag(windowname)
        if (e !== null) {
            var rect = e.target.getBoundingClientRect();
            setleft(e.clientX - rect.left)
            settop(e.clientY - rect.top)
            setDragWindow(drag)
            if (drag === true && windowname !== null) {
                resetzindexes(windowname)
            }
        }

    }

    const MouseMove = (e) => {
        if (dragwindow === true && windowtodrag !== null) {
            document.getElementById(windowtodrag).style.top = (e.clientY - (10 - window.pageYOffset)) + "px"
            document.getElementById(windowtodrag).style.left = (e.clientX - (left - window.pageXOffset)) + "px"
        }
    }
    //onselectme
    const onselectme = (e) => {
        // do nothing
    }

    return (
        <>
            <div className="fullscreen" id="FullscreenBlocker">
                <div id="Rotatinglines" className="checkingatworkstatusmessage">
                    <center>
                        <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true} className="spinner"
                        />
                        <br></br>
                        <div id="RotatinglinesText">Gegevens worden verwerkt, even geduld aub</div>
                    </center>
                </div>
            </div>
            <div id="main">

                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button>
                        </div>
                    </div>
                </header>
                <div id="content">
                    <div id="messagetopdiv" className='messagetop'></div>
                    <form className="form">
                        <div id="legend" className='legend'>
                            <label className='formtitle'>{t('Overzichttaken')}</label>
                            <div className={"CleaningTypeButton_status0 legendbutton"}>{t('assigned')}<br /> [0] </div>
                            <div className={"CleaningTypeButton_status6 legendbutton"}>{t('DND')}<br /> [6]</div>
                            <div className={"CleaningTypeButton_status1 legendbutton"}>{t('started')}<br /> [1]</div>
                            <div className={"CleaningTypeButton_status2 legendbutton"}>{t('QAcontroled')}<br /> [2]</div>
                            <div className={"CleaningTypeButton_status3 legendbutton"}>{t('readyforQA') + " [3]"}</div>
                            <div className={"CleaningTypeButton_status4 legendbutton"}>{t('Issuereported') + " [4]"}</div>
                            <div className={"CleaningTypeButton_status5 legendbutton"}>{t('Redo')}<br /> [5]</div>
                            <div className={"CleaningTypeButton_status7 legendbutton"}>{t('RedoStarted') + " [7]"} </div>
                        </div>
                        <div className="checkboxQAContainer">
                            <label htmlFor="checkboxQAcontrolled">
                                {t("show_QATasks")}:
                            </label>
                            <input
                                id="checkboxQAcontrolled"
                                type="checkbox"
                                onChange={onchangeQAcontrolled}
                            />
                            <div className="checkboxQAContainer">
                                <label>
                                    {t('Rooster datum')}:
                                </label>
                                <input type="date" id="selectedRoosterDate" className='datepicker' placeholdertext="dd/mm/yyyy" dateformat="dd/MM/yyyy" onChange={Refreshsupervisorcleaningassignmentsfordate} />
                            </div>
                        </div>
                        <Tabs className="HotelTabs" id="taboverview" selectedIndex={selectedtab} onSelect={onselectme}>
                            <TabList id="tablisthoteloverview">
                                {tabs}
                            </TabList>
                            {tabpanelscontent}
                            {/* {tabpanels} */}
                        </Tabs>
                    </form>
                </div>
                <div id="coverAll" className="subscreen" onMouseMove={MouseMove}>
                    <QualityControlNode rights={props.right} t={t} assignmentDisabled={assignmentDisabled} data={cleaningassignment} events={{ handleOnchangeCheck: handleOnchangeCheck, handleCancel: handleCancel, handleCheck: handleCheck, handleOnchange: handleQAOnchange, handleQACheck: handleQACheck, QAChecked: QAChecked, RECLEANChecked: RECLEANChecked, startdrag: startdrag }} />
                    <IssueReportNode rights={props.right} t={t} assignmentDisabled={assignmentDisabled} data={cleaningassignment} events={{ handleCancel: handleCancel, handleCheck: handleCheckissue, handleOnchange: handleOnchange, handleIssue: handleIssue, startdrag: startdrag }} />
                    <AssignmentDetailNode rights={props.right} t={t} assignmentDisabled={assignmentDisabled} data={cleaningassignment} events={{ handleCancel: handleCancel, handleCheck: handleCheckissue, handleOnchange: handleOnchange, handleIssue: handleIssue, startdrag: startdrag }} />
                    <Dagstaat_per_medewerker rights={props.right} t={t} hotelid={selectedhotel} selecteddate={selectedDate} events={{ handleCancel: closereport, showdetails: showdetails, startdrag: startdrag }} />
                </div>

            </div>
        </>
    )

}

export default ViewCleaningAssignments